import app from 'flarum/forum/app';

import LinkButton from "flarum/common/components/LinkButton";
import Component from "flarum/Component";

export default class TabComponent extends Component {
  private page: string = ""
  private siteId: string = ""
  private apiKey: string = ""
  private timer: number = 0

  oninit(vnode) {
    super.oninit(vnode);

    this.page = this.attrs.page
    this.siteId = this.attrs.siteId
    this.apiKey = this.attrs.apiKey
    this.timer = this.attrs.timer
  }

  view() {
    return (
      <div class="pt-site-tabs">
        <div className={this.page === 'info' ? 'pt-site-tab selected' : 'pt-site-tab'}>
          {
            LinkButton.component({
              href: '/pt/site/info/' + this.siteId + '/' + this.apiKey,
              onclick: ()=> {
                clearInterval(this.timer)
              }
            }, app.translator.trans('mattoid-pt-site-information.forum.tabs.tab-info'))
          }
        </div>
        <div className={this.page === 'hr' ? 'pt-site-tab selected' : 'pt-site-tab'}>
          {
            LinkButton.component({
              href: '/pt/site/hr/' + this.siteId + '/' + this.apiKey,
              onclick: ()=> {
                clearInterval(this.timer)
              }
            }, app.translator.trans('mattoid-pt-site-information.forum.tabs.tab-hr'))
          }
        </div>
        <div className={this.page === 'box' ? 'pt-site-tab selected' : 'pt-site-tab'}>
          {
            LinkButton.component({
              href: '/pt/site/box/' + this.siteId + '/' + this.apiKey,
              onclick: ()=> {
                clearInterval(this.timer)
              }
            }, app.translator.trans('mattoid-pt-site-information.forum.tabs.tab-box'))
          }
        </div>
        <div className={this.page === 'check' ? 'pt-site-tab selected' : 'pt-site-tab'}>
          {
            LinkButton.component({
              href: '/pt/site/check/' + this.siteId + '/' + this.apiKey,
              onclick: ()=> {
                clearInterval(this.timer)
              }
            }, app.translator.trans('mattoid-pt-site-information.forum.tabs.tab-check'))
          }
        </div>
        <div className={this.page === 'claim' ? 'pt-site-tab selected' : 'pt-site-tab'}>
          {
            LinkButton.component({
              href: '/pt/site/claim/' + this.siteId + '/' + this.apiKey,
              onclick: ()=> {
                clearInterval(this.timer)
              }
            }, app.translator.trans('mattoid-pt-site-information.forum.tabs.tab-claim'))
          }
        </div>
        <div className={this.page === 'level' ? 'pt-site-tab selected' : 'pt-site-tab'}>
          {
            LinkButton.component({
              href: '/pt/site/level/' + this.siteId + '/' + this.apiKey,
              onclick: ()=> {
                clearInterval(this.timer)
              }
            }, app.translator.trans('mattoid-pt-site-information.forum.tabs.tab-level'))
          }
        </div>
      </div>
    )
  }
}
